






































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import { Route } from "vue-router";
import AnnoucementService from '@/services/researchCenter.service';
import ResearchCenter from '../../models/research/ResearchCenter/reseachCenter.model';
import FacultyTable from './table.vue';

@Component({
    components: {
        FacultyTable
    }
})
export default class BaseFaculty extends BaseVue {
    isLoading: boolean = false;
    repository: AnnoucementService = new AnnoucementService();
    researchCenters: any = [];
    activeTab: number = 0;

    async mounted() {
        this.isLoading = true;
        this.researchCenters = await this.repository.getFacultiesById(this.user.id);    
        this.isLoading = false;
        setTimeout(() => {
            if (this.$route.params.id) {
                let id = Number(this.$route.params.id);
                let tabSelected = this.researchCenters.findIndex(x => x.id == id);
                this.activeTab = tabSelected;
            }
        }, 100);
    }

    get user() {
      return this.$store.state.user;
    }

    add(researchCenterId: number) {
        this.$router.push(`/faculties/agregar/${researchCenterId}`);
    }
}
